<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <div class="text-justify intro-text">
                  <span>تصویرآیکون سامانه برخط ناظریک بر روی صفحه موبایل</span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/iconPic.jpg" alt="img" class="img-fluid col-6"/></div>
                  <span> بعضی از صفحات سامانه برخط ناظریک بر روی صفحه موبایل</span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/loading.jpg"  alt="img" class="img-fluid col-5"/></div>
                  <h1 class="text-black">تصویر صفحه یک کاریر سامانه در حال ثبت پلاک ماشینِ کشف حجاب کرده</h1>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/info1.jpg"  alt="img" class="img-fluid col-5"/></div>
                  <span> قسمتی از صفحه (گزارش ثبت تخلفات قبلی) یک کاربر </span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/info2.png"  alt="img" class="img-fluid col-5"/></div>
                  <span>نمایی از گزینه های دیگر سامانه برخط ناظر یک </span><br>
                  <div class="image justify-content-center align-items-center"><img src="@/assets/menuList.png"  alt="img" class="img-fluid col-5"/></div>
                </div>

                <RouterLink to="/introSecond" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/introFourth" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.intro-text{
  font-family: Calibri,sans-serif;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/

</script>
